import * as types from '../mutation-types'

export default {
    namespaced: true,
    state:{
        materials:[],
        myMaterials: [],
        materialBrief: []
    },

    actions:{
        fetchAll({ commit }){
            return window.axios.get('/materials', { once: true }).then((response) => {
                commit(types.STORE_MATERIALS, response.data)
                return response.data;
            })
        },

        fetchBrief ({ commit }, { employeeId, withPrices }) {
            return window.axios.get('/materials/brief', { once: true }, { params: { employeeId, withPrices } }).then(({ data }) => {
                commit(types.STORE_MATERIALS_BRIEF, data)
                return data
            })
        },

        fetchById({ commit }, { id }){
            return window.axios.get(`/materials/${id}`).then((response) => {
                return response.data;
            })
        }, 
        
        fetchByFilter({ commit }, { name, materialFormId, withPrices, active }){
            return window.axios.get('/materials', {
                params:{
                    name,
                    materialFormId,
                    withPrices,
                    active
                }
            })
            .then((response) => {
                return response.data
            })
        },

        create({ commit }, { data }){
            return window.axios.post('/materials', data);
        },

        update({ commit }, { id, data }){
            return window.axios.put(`materials/${id}`, data);
        },

        fetchMyMaterial ({ commit }, { employeeId, withPrices }) {
            return window.axios.get('materials/mine', { params: { employeeId, withPrices } }).then(({ data }) => {
                commit(types.STORE_MINE_MATERIALS, data)
                return data
            })
        },

        updateMaterialsForSpecialty({ commit }, { id, materials }) {
            return window.axios.put(`/specialty/${id}/materials`, materials).then(({ data }) => {
                return data
            })
        },

        updateSpecialtyForMaterials({ commit }, { id, materials }) {
            return window.axios.put(`/materials/${id}/specialties`, materials).then(({ data }) => {
                return data
            })
        },

        fetchMaterialByTeam({ commit }, { teamId }) {
            return window.axios.get(`/materials/team/${teamId}`).then(({ data }) => {
                return data
            })
        },

        fetchMaterialForSpecialties({ commit }, { specialtyIds }) {
            var urlSearchParams = new URLSearchParams();
            specialtyIds.forEach(id => {
                urlSearchParams.append('specialtyIds', id)
            })
            return window.axios.get('/materials/specialties', { params: urlSearchParams }).then(({ data }) => {
                return data
            })
        },

        updatePrices({ commit }, { id, newPrices }) {
            return window.axios.put(`materials/${id}/prices`, newPrices)
        },

        fetchMaterialsTeams ({ commit }, { teamId, fromDate, toDate }) {
            return window.axios.get(`materials/team/${teamId}`, { params: { fromDate, toDate } }).then(({ data }) => {
                return data
            })
        },
        
        changeStatus ({ commit }, { materialId, active }) {
            return window.axios.put(`materials/${materialId}/status`, {}, { params: { active } })
        },

        reset ({ commit }) {
            commit(types.RESET)
        },

        deleteTeamSpecialtyMaterial ({ commit }, { id }) {
            return window.axios.delete(`/materials/teamSpecialistMaterial/${id}`).then(({ data }) => {
                return data
            })
        }
    },

    mutations:{
        [types.STORE_MATERIALS](state, materials){
            state.materials = materials.sort(function(a, b) { if (a.name < b.name) { 
                return -1
            }; 
            if (a.name > b.name) {
                return 1 
            }; 
                return 0 
            });
        },

        [types.STORE_MINE_MATERIALS] (state, myMaterials) {
            state.myMaterials = myMaterials
        },

        [types.STORE_MATERIALS_BRIEF](state, materialBrief) {
            state.materialBrief = materialBrief
        },

        [types.RESET](state) {
            state.materials = []
            state.myMaterials = []
            state.materialBrief = []
        }
    },

    getters:{
        getMaterialById: state => id => state.materials.find(c => c.id === id),
        getMaterialByName: state => name => state.materials.find(c => c.name === name),
        getMaterialBriefById: state => id => state.materialBrief.find(c => c.id === id),
    }
}